export const HR_CYCLE_EN = {
    // ── offboarding (#44): Art. 82, the listing on exit, the settlement's net ──
    'change.field.entry.source_ref': 'From the end-of-service case',
    "value.reason.annual_leave": "Annual leave",
    "value.reason.decision": "Administrative decision",
    "value.kind.full": "Full",
    "value.kind.partial": "Partial",
    "value.status.requested": "Requested",
    "value.leave_type.emergency": "Emergency (unpaid)",
    "value.kind.strength": "Strength",
    "value.kind.weakness": "Weakness",
};
export const HR_CYCLE_AR = {
    'change.field.entry.source_ref': 'من ملف إنهاء الخدمة',
    "value.reason.annual_leave": "إجازة سنوية",
    "value.reason.decision": "قرار إداري",
    "value.kind.full": "كامل",
    "value.kind.partial": "جزئي",
    "value.status.requested": "مطلوب",
    "value.leave_type.emergency": "اضطرارية (بلا أجر)",
    "value.kind.strength": "نقطة قوة",
    "value.kind.weakness": "نقطة ضعف",
};
//# sourceMappingURL=i18n-hr-cycle.js.map